'use client'

// Third-party Imports
import { useEffect } from 'react'

import classnames from 'classnames'

// Type Imports

import type { ChildrenType } from '@core/types'

// Hook Imports
import { useSettings } from '@core/hooks/useSettings'

// Util Imports
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses'

// Styled Component Imports
import StyledMain from '@layouts/styles/shared/StyledMain'

const LayoutContent = ({ children }: ChildrenType) => {
  // Hooks
  const { settings } = useSettings()

  // Vars
  const contentCompact = settings.contentWidth === 'compact'
  const contentWide = settings.contentWidth === 'wide'

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement

      if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) {
        return
      }

      const isQuote = e.key === "'" || e.key === '"'

      if (isQuote) {
        e.preventDefault()
      }
    }

    const handleInput = (e: Event) => {
      const target = e.target as HTMLInputElement | HTMLTextAreaElement

      if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) {
        return
      }

      const hasQuotes = /['"]/.test(target.value)

      if (hasQuotes) {
        target.value = target.value.replace(/['"]/g, '')
      }
    }

    const handleFocusIn = (e: FocusEvent) => {
      const target = e.target as HTMLElement

      if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) {
        return
      }

      if (['button', 'submit', 'checkbox', 'radio', 'file'].includes(target.type)) {
        return
      }

      if (target.dataset.autoSelect === 'false') {
        return
      }

      target.select()
    }

    // Satu kali attach semua
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('input', handleInput)
    document.addEventListener('focusin', handleFocusIn)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('input', handleInput)
      document.removeEventListener('focusin', handleFocusIn)
    }
  }, [])

  return (
    <StyledMain
      isContentCompact={contentCompact}
      className={classnames(verticalLayoutClasses.content, 'flex-auto', {
        [`${verticalLayoutClasses.contentCompact} is-full`]: contentCompact,
        [verticalLayoutClasses.contentWide]: contentWide
      })}
      style={{
        // ✅ Tambahkan style untuk full height
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        flexGrow: 1
      }}
    >
      {children}
    </StyledMain>
  )
}

export default LayoutContent
